import { useGame } from '../state/store'
import { fmt } from '../engine/decimal'

export function OfflineModal() {
  const gain = useGame((s) => s.offlineGain)
  const dismiss = useGame((s) => s.dismissOffline)
  if (!gain) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4">
      <div className="w-full max-w-sm rounded-lg border border-ink-border bg-ink-panel p-6 text-center shadow-glow">
        <h2 className="text-sm font-bold uppercase tracking-widest text-ink-teal">
          While you were away
        </h2>
        <p className="mt-3 text-3xl font-extrabold text-ink-text">+{fmt(gain)}</p>
        <p className="text-xs text-ink-muted">Ink generated offline</p>
        <button
          onClick={dismiss}
          className="mt-5 w-full rounded-md border border-ink-tealdim bg-ink-bg py-2 text-sm font-bold text-ink-teal hover:bg-ink-border"
        >
          Collect
        </button>
      </div>
    </div>
  )
}
